import React, { useEffect, useState } from "react";
import {
    Container,
    Typography,
    Button,
    Box,
    Grid,
    List,
    ListItem,
    ToggleButton,
    ToggleButtonGroup,
    useTheme,
} from "@mui/material";
import { styled } from "@mui/system";
import { useParams } from "react-router-dom";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

import Navbar from "./Navbar";
import Footer from "./Footer";
import creditCardData from "../JSON/creditCardData.json";

/* ================= HERO ================= */
const StyledHero = styled(Box)(({ theme, backgroundImage }) => ({
    backgroundImage: `
    linear-gradient(
      to right,
      ${theme.palette.primary.main},
      #3fa9a4
    ),
    url('${backgroundImage}')
  `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(6, 2),
    height: 300,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
}));

const CreditCardsPage = () => {
    const { id } = useParams();
    const theme = useTheme();
    const [activeSection, setActiveSection] = useState("description");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const selectedCard = creditCardData.find((c) => c.id === id);

    if (!selectedCard) {
        return (
            <Typography sx={{ textAlign: "center", mt: 6 }}>
                Credit Card Data Not Found
            </Typography>
        );
    }

    const { hero, card, applyNowUrl } = selectedCard;

    return (
        <>
            {/* HERO */}
            <StyledHero backgroundImage={hero.backgroundImage}>
                <Container maxWidth="md">
                    <Typography
                        sx={{
                            fontWeight: 800,
                            fontSize: { xs: "1.8rem", md: "3rem" },
                        }}
                    >
                        {hero.title}
                    </Typography>
                    <Typography sx={{ opacity: 0.9 }}>
                        {hero.subtitle}
                    </Typography>
                </Container>
            </StyledHero>

            {/* CARD IMAGE */}
            <Box sx={{ mt: -6, px: 2 }}>
                <Box
                    sx={{
                        maxWidth: 300,
                        mx: "auto",
                        p: 2,
                        bgcolor: theme.palette.background.paper,
                        borderRadius: 3,
                        boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                    }}
                >
                    <Box
                        component="img"
                        src={card.image}
                        alt={hero.title}
                        sx={{ width: "100%", borderRadius: 2 }}
                    />
                </Box>
            </Box>

            {/* FEATURES */}
            <Box sx={{ p: 4 }}>
                <Typography
                    sx={{
                        textAlign: "center",
                        fontSize: "1.8rem",
                        fontWeight: 700,
                        color: theme.palette.text.primary,
                        mb: 3,
                    }}
                >
                    Card Features
                </Typography>

                <Grid container spacing={3}>
                    {card.features.map((feature, i) => (
                        <Grid item xs={12} md={4} key={i}>
                            <Box
                                sx={{
                                    p: 2,
                                    display: "flex",
                                    gap: 2,
                                    bgcolor: theme.palette.secondary.main,
                                    borderRadius: 2,
                                }}
                            >
                                <CheckCircleOutlineIcon color="primary" />
                                <Typography>{feature}</Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>

                <Box sx={{ textAlign: "center", mt: 4 }}>
                    <Button
                        variant="contained"

                        onClick={() => window.open(applyNowUrl, "_blank")}
                        sx={{
                            // backgroundColor: "#0080a7",

                            px: 4,
                            // py: 1.2,
                            // textTransform: "none",
                            // fontWeight: 600,



                            //  mt: 2,
                            backgroundColor: theme.palette.primary.main,
                            color: "#fff",
                            fontWeight: 600,
                            borderRadius: "8px",
                            textTransform: "none",
                            "&:hover": {
                                backgroundColor: theme.palette.primary.dark,
                            },

                        }}
                    >
                        Apply Now
                    </Button>
                </Box>
            </Box>

            {/* TABS */}
            <Box sx={{ textAlign: "center" }}>
                <ToggleButtonGroup
                    value={activeSection}
                    exclusive
                    onChange={(e, v) => v && setActiveSection(v)}
                >
                    {["description", "eligibility", "charges"].map((sec) => (
                        <ToggleButton key={sec} value={sec}>
                            {sec.toUpperCase()}
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>
            </Box>

            {/* CONTENT */}
            {["description", "eligibility", "charges"].map(
                (sec) =>
                    activeSection === sec &&
                    card[sec === "charges" ? "chargesAndFees" : sec] && (
                        <Box sx={{ p: 4 }} key={sec}>
                            <Typography sx={{ fontWeight: 700, mb: 2 }}>
                                {sec.toUpperCase()}
                            </Typography>
                            <List>
                                {card[sec === "charges" ? "chargesAndFees" : sec].map(
                                    (item, i) => (
                                        <ListItem key={i}>
                                            <FiberManualRecordIcon
                                                fontSize="small"
                                                color="primary"
                                                sx={{ mr: 1 }}
                                            />
                                            <Typography>{item}</Typography>
                                        </ListItem>
                                    )
                                )}
                            </List>
                        </Box>
                    )
            )}

            <Footer />
        </>
    );
};

export default CreditCardsPage;
